import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const ActivationTransferFundsPage = () => {
  const [data, setData] = useState({
    wallet_balance: "",
    amount: "",
    txn_password: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_transferfunds_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_transferfunds_form_card"
      >
        <div className="mono_section_title">
          <h2>Fund Transfer To Activation Wallet</h2>
        </div>
        <div className="mono_transferfunds_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Withdrawal Wallet Balance"
                type="text"
                name="wallet_balance"
                placeholder="Enter withdrawal wallet balance"
                onChange={(e) =>
                  setData({ ...data, wallet_balance: e.target.value })
                }
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Input
                label="Enter Amount"
                type="text"
                name="amount"
                placeholder="Enter amount"
                onChange={(e) => setData({ ...data, amount: e.target.value })}
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Input
                label="Txn Password"
                type="text"
                name="txn_password"
                placeholder="Enter txn password"
                onChange={(e) =>
                  setData({ ...data, txn_password: e.target.value })
                }
                className="input_field"
              />
            </div>
            <Button type="submit" className="submit_btn">
              transfer
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default ActivationTransferFundsPage;
